import axios from "axios";
import config from "../../../config/index";

import {
    MESSAGES_LIST,
    MESSAGES_LIST_ERROR,
    MESSAGES,
    MESSAGES_EDIT,
    MESSAGES_ONE_ERROR,
    LAST_MESSAGES,
} from "../types/types";

const instance = axios.create({
    baseURL: config.SIM_API_URL,
    timeout: 30000,
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {

    if(error.response.status === 403) {
        localStorage.setItem("role", '');
        localStorage.setItem("client", '');
        localStorage.setItem("client_id", '');
        localStorage.setItem("client_name", '');
        localStorage.setItem("client_email", '');
        window.location.href = "/login";
    }
    return Promise.reject(error);
});

export const registerMessages = (data) => dispatch => {
    instance
        .post("api/message/register-message", data)
        .then(res => {

        })
        .catch(err => {
            dispatch({
                type: MESSAGES,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
            console.log(err && err.response && err.response.data && err.response.data.msg);
        })
};

export const getMessagesToProviderId = (data) => dispatch => {
    instance
        .post("api/message/get-messages", data)
        .then(res => {
            dispatch({
                type: MESSAGES_LIST,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({
                type: MESSAGES_LIST_ERROR,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
            console.log(err && err.response && err.response.data && err.response.data.msg);
        })
};

export const deleteMessage = (data) => dispatch => {
    instance
        .post("api/message/delete-message", data)
        .then(res => {
            console.log(res.data.msg);
        })
        .catch(err => {
            console.log(err && err.response && err.response.data && err.response.data.msg);
        })
};

export const getEditMessage = (data) => dispatch => {
    instance
        .post("api/message/get-edit-message", data)
        .then(res => {
            dispatch({
                type: MESSAGES_EDIT,
                payload: res.data.results,
            });
        })
        .catch(err => {
            dispatch({
                type: MESSAGES_ONE_ERROR,
                payload: err && err.response && err.response.data && err.response.data.msg,
            });
        })
};

export const updateMessage = (data) => dispatch => {
    instance
        .post("api/message/update-message", data)
        .then(res => {
            console.log(res.data.msg);
        })
        .catch(err => {
            console.log(err && err.response && err.response.data && err.response.data.msg);
        })
};

/**
 * Only ID, Name, and List of the last messages with connected clients
 */
export const lastMessageList = (data) => dispatch => {
    instance
        .post("api/message/get-last-messages", data)
        .then(res => {
            if(res.data.results.length !== 0){
                dispatch({
                    type: LAST_MESSAGES,
                    payload: res.data.results,
                });
            }
        })
        .catch(err => {
            console.log(err.toString());
        })
};
